module.exports = __webpack_public_path__ + "static/media/SoftMakerVolkswagenSerial.9de26ab2.otf";